import { Outlet } from "react-router-dom";
import InternalHeader from "../components/InternalHeader";

export default function InternLayout() {
  return (
    <div className="min-h-screen bg-[#F8FAFA]">
      <InternalHeader />

      <main className="max-w-6xl mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}